// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67e22ae6","239":"4670a86c","732":"3f27aafb"}[chunkId] + ".chunk.js";
};